import AuthService from '../services/AuthServices';
import fbLogo from '../assets/Facebook_Logo_2019.png';
import '../styles/FacebookLoginButton.css';

function FacebookLoginButton() {

  function handleFacebookLogin() {
    if (!window.FB) {
      alert("Facebook SDK non chargé");
      return;
    }

    window.FB.login(response => {
      if (response.authResponse) {
        // L'utilisateur s'est connecté
        window.FB.api('/me', { fields: 'name,email' }, userData => {
          console.log("Utilisateur connecté via Facebook :", userData);

          // ⚠️ Tu peux maintenant appeler ton back PHP avec userData.email
          sendLoginRequest(response.authResponse.accessToken);

        });
      } else {
        alert("Connexion Facebook annulée");
      }
    }, { scope: 'email' });
  }

  function sendLoginRequest(accessToken) {
    fetch("https://app.listaki.fr/api/WS/facebook-login.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ accessToken }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.key) {
          AuthService.setConnectedKey(data.key);
          // window.location.reload();
          window.location.href = "/"; // Redirection vers la page d'accueil, car si on est sur /register le relod reste sur la page d'inscription

        } else {
          alert("Erreur d'authentification Facebook.");
        }
      });
  }


  return (
    <button className="social-login-button" onClick={() => {
                                                          if (window.umami) window.umami.track('login-facebook-click');
                                                          handleFacebookLogin();
                                                        }}>
      <img src={fbLogo} alt="Facebook" className="social-login-icon" />
      Se connecter avec Facebook
    </button>
  );

}

export default FacebookLoginButton;
